import { getMessages } from '../../../../../../store/constants';

export const SIGN_IN_POPUP_TITLE = getMessages().getText('signin.popup.title');
export const SIGN_IN_POPUP_TEXT = getMessages().getText('signin.popup.text');

export const CLASS_SIGN_IN = 'signin';

export const SIGN_IN_IMG_LOADED_SESSIONSTORAGE = 'SIGN_IN_IMG_LOADED_SESSIONSTORAGE';
